import { z } from "zod";

export const schema = z.object({
	parcelas: z.array(
		z.object({
			id: z.number(),
			id_forma: z.number().int().min(1, "Forma de Pagamento é obrigatório"),
			id_conta: z.number().int("Campo Conta é obrigatorio"),
			parcela: z.number().nullable(),
			parcela_total: z.number().nullable(),
			valor: z
				.union([z.string(), z.number()])
				.transform((value) => {
					// Se for string, converte para número
					if (typeof value === "string") {
						const parsedValue = parseFloat(value.replace(",", "."));
						return isNaN(parsedValue) ? 0 : parsedValue;
					}
					return value; // Já é número, mantém como está
				})
				.refine((val) => val > 0, {
					message: "O valor deve ser maior que zero. Corrija o valor ou gere novamente as parcelas.",
				}),
			data_vencimento: z.string().nonempty("A data é obrigatória"),
			ativo: z.boolean(),
		})
	),
});
